/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var momentUtil = require('common/util/momentUtil');
var _ = require('underscore');

module.exports = function(data) {
  var startDateTimeStr = data.startDate + ' ' + data.startTime;
  var startDateTime = momentUtil.formatStr(
    startDateTimeStr,
    _.extend({}, momentUtil.defaultOutboundDateTimeConfig, { sourceFormat: 'MM/DD/YYYY hh:mm A' })
  );
  var endDateTimeStr = data.endDate + ' ' + data.endTime;
  var endDateTime = momentUtil.formatStr(
    endDateTimeStr,
    _.extend({}, momentUtil.defaultOutboundDateTimeConfig, { sourceFormat: 'MM/DD/YYYY hh:mm A' })
  );

  var eventJson = {
    subject: data.eventTitle,
    body: {
      contentType: 'Text',
      content: data.eventDescription
    },
    start: {
      dateTime: startDateTime,
      timeZone: 'Eastern Standard Time'
    },
    end: {
      dateTime: endDateTime,
      timeZone: 'Eastern Standard Time'
    }
  };

  return $.soap({
    body: {
      SubmitEditEventDetails: {
        $xmlns: 'http://dobs.pa.gov/co/event/bpm/1.0',
        EventID: data.eventId,
        EventTypeID: data.eventTypeId,
        Title: data.eventTitle,
        Description: data.eventDescription,
        Program1: data.program1Id,
        TargetAudienceID: data.targetAudienceId,
        WhoPromoted: data.whoPromoted,
        HowPromoted: data.howPromoted,
        EventNotes: data.eventNotes,
        IsRegRequired: data.isRegistrationRequired,
        RegDetails: data.registrationDetails,
        Attendance: data.attendance,
        EventFormatID: data.eventFormatId,
        StartDateTime: startDateTime,
        EndDateTime: endDateTime,
        EventDetailsJSON: JSON.stringify(eventJson)
      }
    }
  });
};
